import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {StudentNoteCategory} from './student-note-category.model';
import {Observable} from 'rxjs';
import {YearService} from '../../shared-components/year/year.service';
import {System} from '../../shared-components/System';
import {StudentNote} from './student-note.model';
import {School} from '../../shared-components/year/school.model';
import {SharedService} from '../../shared-components/shared.service';

@Injectable()
export class StudentNotesService {

    // Properties
    addEditSchools: School[] = [];
    viewSchools: School[] = [];
   
    // Class Functions
    constructor(
        private yearService: YearService,
        private http: HttpClient,
        private sharedService: SharedService
    ) {
    }

    // Methods
    getStudentNotesCategories(): Observable<StudentNoteCategory[]> {
        // POST: Gets the student notes categories from the server
        return this.sharedService.getStudentNoteCategories(this.yearService.defaultYear.SchoolID, this.yearService.defaultYear.Id);
    }

    getStudentNotes(): Observable<StudentNote[]> {
        // POST: obtains the student notes for this user from the server
        // NOTE: on the server, they accidentally used these backwards
        const queryString = '?schoolId=' + this.yearService.defaultYear.Id +
            '&yearId=' + this.yearService.defaultYear.SchoolID;
        return this.http.get<StudentNote[]>(System.apiURL.Classroom + 'GetStudentNotesByUserId' + queryString);
    }

    addStudentNote(note: StudentNote): Observable<number> {
        // PRE: a note to add for a student
        // POST: adds that note to the server which returns the Id
        return this.http.post<number>(System.apiURL.Classroom + 'AddStudentNote', note);
    }

    addStudentNotes(notes: StudentNote[]): Observable<void> {
        // PRE: a list of notes to add
        // POST: adds those notes to the server
        return this.http.post<void>(System.apiURL.Classroom + 'AddStudentNotes', notes);
    }

    updateStudentNotes(notes: StudentNote[]): Observable<void> {
        // PRE: a list of notes to update
        // POST: updates those notes on the server
        return this.http.post<void>(System.apiURL.Classroom + 'UpdateStudentNotes', notes);
    }

    deleteStudentNote(noteId: number): Observable<void> {
        // PRE: the id of the note you want to delete
        // POST: deletes the note from the server
        const queryString = '?noteId=' + noteId;
        return this.http.get<void>(System.apiURL.Classroom + 'DeleteStudentNote' + queryString);
    }
}
